<template>
	<div class="primary-main bank-main school-manage" v-loading="loading">
		<div class="search">
			<el-select v-model="jbId" :popper-append-to-body="false" clearable filterable placeholder="级别" style="width: 110px;margin-bottom: 10px;">
				<el-option v-for="item in dlsjbList" :key="item.id" :label="item.jbmc" :value="item.id"></el-option>
			</el-select>
<!--			<el-select v-model="cscode" :popper-append-to-body="false" filterable placeholder="所属城市"	clearable style="width: 170px;margin-bottom: 10px;">
				<el-option v-for="item in csList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
			</el-select>-->
      <el-cascader style="width: 170px;margin: 0 10px 10px 0;"
          placeholder="所属城市"
          v-model="cscode"
          :options="cityTree"
          :props="cascaderProps"
          :show-all-levels="false"
          clearable>
      </el-cascader>
      <el-select v-model="zhzt" :popper-append-to-body="false" filterable placeholder="账户状态" clearable style="width: 12%;">
				<el-option value="0" label="已禁用">已禁用</el-option>
				<el-option value="1" label="启用中">启用中</el-option>
			</el-select>
			<el-input v-model="dlsmc" placeholder="代理商、代理商编码、负责人、手机号" clearable style="width: 290px;margin-bottom: 10px;"></el-input>
			<el-button @click="searchDlsglPage" style="margin-bottom: 10px;" icon="el-icon-search">查询</el-button>
      <el-button type="primary" class="search-btn" @click="dlsglExport" style="margin-bottom: 10px;" icon="el-icon-download">导出</el-button>
      <el-button type="primary" @click="showSaveDlsgl()" style="margin-bottom: 10px;" icon="el-icon-plus">新增</el-button>
		</div>
		<el-table :data="tableData" border :header-cell-style="{ 'text-align': 'center' }"
			:cell-style="{ 'text-align': 'center' }" style="width: 100%">
			<el-table-column type="index" label="序号" width="80"></el-table-column>
			<el-table-column prop="dlsbm" label="代理商编码" width="100"></el-table-column>
			<el-table-column prop="dlsmc" label="代理商名称"></el-table-column>
			<el-table-column prop="jbmc" label="级别" width="80"></el-table-column>
			<el-table-column label="业务" width="200">
				<template slot-scope="scope">
					<span v-if="scope.row.ywList && scope.row.ywList.length">
						<span v-for="(item, index) in scope.row.ywList" :key="index">
							{{ item.ywmc || getYwName(item.ywcode) }}（{{ item.rs }}人）<i v-if="index!=scope.row.ywList.length-1">，</i>
						</span>
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="csmc" label="所在城市"></el-table-column>
			<el-table-column prop="fzr" label="负责人"></el-table-column>
			<el-table-column prop="sjh" label="手机号"></el-table-column>
			<el-table-column label="账户余额积分" width="200">
        <template slot-scope="scope">
          <div v-if="scope.row.ywList && scope.row.ywList.length">
            <span v-for="(item, index) in scope.row.ywList" :key="index">
              {{ item.ywmc || getYwName(item.ywcode) }}：{{ item.zhyejf }}<i v-if="index!=scope.row.ywList.length-1">，</i>
            </span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="账户状态" width="100">
        <template slot-scope="scope">
          <el-tag size="mini" v-if="scope.row.zhzt==1">启用中</el-tag>
          <el-tag size="mini" v-if="scope.row.zhzt==0" type="danger">已禁用</el-tag>
        </template>
      </el-table-column>
			<el-table-column label="操作" width="150">
				<template slot-scope="scope">
<!--					<el-button type="text" @click="showDlsJfList(scope.row.id)">积分记录</el-button>-->
          <el-button type="text" @click="showSaveDlsgl(scope.row.id)">编辑</el-button>
          <el-button type="text" @click="dlsglDel(scope.row.id)" v-if="scope.row.zhzt==0">删除</el-button>
          <el-button type="text" @click="dlsglZtEdit(scope.row.id,1)" v-if="scope.row.zhzt==0">启用</el-button>
          <el-button type="text" @click="dlsglZtEdit(scope.row.id,0)" v-if="scope.row.zhzt==1">禁用</el-button>
        </template>
			</el-table-column>
		</el-table>
		<el-pagination
        v-if="tableData.length"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total">
		</el-pagination>

    <el-dialog
        title="详情"
        :visible.sync="dlsglSaveDialog"
        width="500px"
        :before-close="handleClose"
        :close-on-click-modal="false">
      <el-form :model="ruleForm" ref="ruleForm" :rules="rules" label-width="135px">
<!--        <el-form-item label="代理商编码：" prop="dlsbm">
          <el-input v-model="ruleForm.dlsbm" placeholder="请输入代理商编码" maxlength="30" show-word-limit></el-input>
        </el-form-item>-->
        <el-form-item label="代理商名称：" prop="dlsmc">
          <el-input v-model="ruleForm.dlsmc" placeholder="请输入代理商名称" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="级别：" prop="jbId">
          <el-select v-model="ruleForm.jbId" :popper-append-to-body="false" clearable filterable placeholder="级别">
            <el-option v-for="item in dlsjbList" :key="item.id" :label="item.jbmc" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="城市：" prop="cscode">
<!--          <el-select v-model="ruleForm.cscode" :popper-append-to-body="false" clearable filterable placeholder="所属城市">
            <el-option v-for="item in csList" :key="item.dictCode" :label="item.dictName" :value="item.dictCode"></el-option>
          </el-select>-->
          <el-cascader
              :disabled="ruleForm.id!==''&&ruleForm.id!==null&&ruleForm.id!=undefined"
              v-model="ruleForm.cscode"
              :options="cityTree"
              :props="cascaderProps"
              :show-all-levels="false"
              clearable>
          </el-cascader>
        </el-form-item>
        <el-form-item label="负责人：" prop="fzr">
          <el-input v-model="ruleForm.fzr" placeholder="请输入负责人" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="手机号：" prop="sjh">
          <el-input v-model="ruleForm.sjh" placeholder="请输入手机号"></el-input>
        </el-form-item>
        <el-form-item label="业务：" prop="ywList">
          <el-checkbox-group v-model="selectedYwIds" @change="handleYwChange">
            <el-checkbox v-for="item in ywList" :key="item.id" :label="item.ywcode" :disabled="isEdit && originalYwIds.includes(item.ywcode)">{{ item.ywmc }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="业务人数：" v-if="selectedYwIds.length > 0">
          <div v-for="ywcode in selectedYwIds" :key="ywcode" style="margin-bottom: 10px;">
            <span style="display: inline-block; width: 150px;">{{ getYwName(ywcode) }}：</span>
            <el-input-number v-model="ywRsMap[ywcode]" :min="0" :max="100000" label="人数" style="width: 150px;"></el-input-number>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary" @click="dlsglSave">确 定</el-button>
      </span>
    </el-dialog>
	</div>
</template>

<script>
export default {
	name: 'dlsglList',
  data() {
		return {
			userType: sessionStorage.getItem("userType"),
      dlsglSaveDialog: false,
			dlsjbList: [],  // 代理商级别列表
      jbId: '',//代理商级别id
			csList: [],  // 城市列表
      cscode: [],//城市编码
      cityTree:[],//城市树型列表
      cascaderProps: { checkStrictly: true,label: 'csmc',value: 'id'},
      zhzt: '',//账户状态
      dlsmc: '',//代理商名称
      curDate: new Date().getTime(),
			tableData: [],
			page: { page: 1, size: 10, total: 0 },
			loading: false,
      ywList: [], // 业务列表
      selectedYwIds: [], // 选中的业务ID列表
      originalYwIds: [], // 编辑时原始选中的业务ID列表
      isEdit: false, // 是否是编辑模式
      ywRsMap: {}, // 业务人数映射 {ywId: rs}
      ruleForm: {
        //dlsbm: '',
        dlsmc: '',
        jbId: '',
        cscode: [],
        fzr: '',
        sjh: '',
        ywList: [],
      },
      rules: {
        /*dlsbm: [
          { required: true, message: '请输入代理商编码', trigger: 'blur' }
        ],*/
        dlsmc: [
          { required: true, message: '请输入代理商名称', trigger: 'blur' }
        ],
        jbId: [
          { required: true, message: '请选择级别', trigger: 'blur' }
        ],
        cscode: [
          { required: true, message: '请选择所属城市', trigger: 'blur' }
        ],
        fzr: [
          { required: true, message: '请输入负责人', trigger: 'blur' }
        ],
        sjh: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          {
            validator: (rule, value, callback) => { // 使用箭头函数绑定上下文
              this.validatePhone(rule, value, callback)
            },
            trigger: 'blur'
          }
        ],
        ywList: [
          { required: true, message: '请选择业务', trigger: 'change' }
        ]
      }
		}
	},
  components:{},
	created() {
    // 获取字典值
    this.sltData();
		//获取代理商分页列表
		this.findDlsglPage();
	},
	methods: {
    // 业务选择变化
    handleYwChange(ywIds) {
      // 初始化新选择业务的人数
      ywIds.forEach(ywId => {
        if (!this.ywRsMap[ywId]) {
          this.$set(this.ywRsMap, ywId, 0);
        }
      });
      // 清除未选业务的rs
      Object.keys(this.ywRsMap).forEach(key => {
        if (!ywIds.includes(key)) {
          this.$delete(this.ywRsMap, key);
        }
      });
      // 手动触发校验
      this.ruleForm.ywList = ywIds;
      this.$refs.ruleForm.validateField('ywList');
    },
    // 根据业务ID获取业务名称
    getYwName(ywcode) {
      const yw = this.ywList.find(item => item.ywcode === ywcode);
      return yw ? yw.ywmc : '';
    },
    validatePhone(rule, value, callback) {
      if (!/^1[3456789]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号'))
      } else {
        callback()
      }
    },
    // 下拉列表数据
    sltData() {
      var _this = this;
      // 代理商级别列表
      _this.$post("admin/ShezhiController/dlsjbList").then(rep => {
        if (rep.code == 1) {
          _this.dlsjbList = rep.result.list;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
      /*// 城市列表
      _this.$post("sys/findSysDictList", { dictType: "G", dictGroup: "104" }).then(rep => {
        if (rep.code == 1) {
          _this.csList = rep.result.dictionaryList;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })*/
      //城市树形菜单
      this.$get("admin/CityController/cityTree").then(response => {
        if(response.code == "1"){
          this.cityTree = response.result.childrenList[0].children;
        }else {
          this.$message({
            type: "error",
            message: response.msg
          })
        }
      })
      // 业务列表
      this.$post("admin/YwController/list", { zt: 1 }).then(rep => {
        if (rep.code == 1) {
          this.ywList = rep.result.list;
        } else {
          this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    // 搜索数据
    searchDlsglPage() {
      this.page.page = 1;
      this.findDlsglPage();
    },
    // 获取数据
    findDlsglPage() {
      var _this = this;
      var params = {
        jbId: _this.jbId,
        cscode: _this.cscode?_this.cscode[_this.cscode.length-1]:null,
        zhzt: _this.zhzt,
        dlsmc: _this.dlsmc,
        page: _this.page.page - 1,
        size: _this.page.size
      }
      _this.loading = true;
      _this.$post("dlsgl/DlsglController/dlsglPage", params).then(rep => {
        _this.loading = false;
        if (rep.code == 1) {
          _this.tableData = rep.result.page.content;
          _this.page.total = rep.result.page.totalElements;
        } else {
          _this.$message({
            type: "error",
            message: rep.msg
          });
        }
      })
    },
    showSaveDlsgl(id){
      var _this = this;
      if(id){
        _this.isEdit = true;
        _this.$post("dlsgl/DlsglController/dlsglView", { id: id }).then(rep => {
          if (rep.code == 1) {
            var dlsgl = rep.result.dlsgl;
            _this.ruleForm.cscode = dlsgl.cscode ? [Number(dlsgl.cscode)] : [];
            _this.ruleForm.id = dlsgl.id;
            _this.ruleForm.dlsmc = dlsgl.dlsmc;
            _this.ruleForm.jbId = dlsgl.jbId;
            _this.ruleForm.fzr = dlsgl.fzr;
            _this.ruleForm.sjh = dlsgl.sjh;
            // 处理业务列表
            if (dlsgl.ywList && dlsgl.ywList.length > 0) {
              _this.selectedYwIds = dlsgl.ywList.map(item => item.ywcode);
              _this.originalYwIds = [..._this.selectedYwIds]; // 保存原始选中的业务ID
              _this.ruleForm.ywList = _this.selectedYwIds; // 用于校验
              _this.ywRsMap = {};
              dlsgl.ywList.forEach(item => {
                _this.$set(_this.ywRsMap, item.ywcode, item.rs || 0);
              });
            } else {
              _this.selectedYwIds = [];
              _this.originalYwIds = [];
              _this.ruleForm.ywList = [];
              _this.ywRsMap = {};
            }
          }
        })
      } else {
        _this.isEdit = false;
        // 新增时清空业务选择和表单
        this.ruleForm = {
          dlsmc: '',
          jbId: '',
          cscode: [],
          fzr: '',
          sjh: '',
          ywList: [],
        };
        _this.selectedYwIds = [];
        _this.originalYwIds = [];
        _this.ywRsMap = {};
      }
      _this.dlsglSaveDialog = true;
    },
		//代理商保存
		dlsglSave() {
			var _this = this;
			_this.$refs.ruleForm.validate((valid) => {
				if (valid) {
          // 构建业务列表数据
          const ywList = [];
          _this.selectedYwIds.forEach(ywcode => {
            ywList.push({
              ywcode: ywcode,
              rs: _this.ywRsMap[ywcode] || 0
            });
          });
          _this.ruleForm.ywList = ywList;

          _this.ruleForm.cscode = _this.ruleForm.cscode[0];
					_this.$post("dlsgl/DlsglController/dlsglSave", _this.ruleForm,'json').then(rep => {
						if (rep.code == 1) {
							_this.$message({
								type: "success",
								message: '保存成功'
							})
							_this.handleClose();
							_this.findDlsglPage();
						} else {
              _this.ruleForm.cscode=[_this.ruleForm.cscode];
              // 恢复ywList为数组以便校验（如果需要）
              _this.ruleForm.ywList = _this.selectedYwIds;
							_this.$message({
								type: "error",
								message: rep.msg
							});
						}
					})
				}
			})
		},
		// 弹窗关闭时
		handleClose() {
      this.ruleForm = {
        dlsbm: '',
        dlsmc: '',
        jbId: '',
        cscode: '',
        fzr: '',
        sjh: '',
        ywList: [], // Ensure ywList is reset as an array
      }
      this.selectedYwIds = [];
      this.originalYwIds = [];
      this.ywRsMap = {};
      this.isEdit = false;
      this.dlsglSaveDialog = false;
      this.$refs.ruleForm.clearValidate();
		},
    //显示积分记录
    showDlsJfList(id){

    },
    // 禁用启用
    dlsglZtEdit(id,zhzt){
      var message = zhzt==1?'启用':'禁用';
      this.$confirm('是否确认'+message, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$post("dlsgl/DlsglController/dlsglZtEdit", { id:id,zhzt:zhzt }).then(rep => {
          if (rep.code == '1') {
            this.$message({
              type: "success",
              message: message+'成功'
            });
            this.findDlsglPage();
          } else {
            this.$message({
              type: "error",
              message: rep.msg
            });
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      })
    },
		// 删除
		dlsglDel(id) {
			this.$confirm('是否确认删除', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$post("dlsgl/DlsglController/dlsglDel", { id: id }).then(rep => {
					if (rep.code == '1') {
						this.$message({
							type: "success",
							message: '删除成功'
						});
						this.findDlsglPage();
					} else {
						this.$message({
							type: "error",
							message: rep.msg
						});
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消'
				});
			})
		},
		// 每页条数
		handleSizeChange(val) {
			this.page.size = val;
			this.findDlsglPage();
		},
		// 当前页
		handleCurrentChange(val) {
			this.page.page = val;
			this.findDlsglPage();
		},
    dlsglExport(){
      var access_token = sessionStorage.getItem("access_token");
      let url = "api/dlsgl/DlsglController/dlsglExport";
      url = url + "?access_token=" + access_token
          +"&jbId="+this.jbId
          +"&zhzt="+this.zhzt
          +"&dlsmc="+this.dlsmc;
      if (this.cscode && this.cscode.length > 0) {
        url = url +"&cscode=" + this.cscode[this.cscode.length-1]
      }
      console.log(url);
      window.location.href = url;
    },

	},
}
</script>

<style lang="less">
.school-manage {
  .el-table::before {
    display: none;
  }
	.search {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 10px;
		.el-select,
		.el-input {
			margin-right: 10px;
		}
	}

	.el-button--text {
		padding: 0
	}

	.el-pagination {
		height: 36px;
		text-align: right;
		margin-top: 20px;
	}
	.content{
		display: flex;
		flex-wrap: wrap;
		margin: 0 20px;
		.listData{
			width: 200px;
			margin-right: 80px;
			margin-bottom: 40px;
			.zt{
				border: 1px solid #ccc;
				background-color: #F2F2F2;
				border-radius: 5px;
				display: flex;
				align-items: center;
				justify-content: center;
				width: 150px;
				height: 70px;
				font-size: 16px;
				position: relative;
				i{
					position: absolute;
					left: 5px;
					top: -20px;
				}
				.el-icon-success{
					color: #67C23A;
				}
				.el-icon-error{
					color: #F56C6C;
				}
				.jiantou{
					position: absolute;
					right: -100px;
					width: 80px;
					height: 3px;
					background-color: #7F7F7F;
					display: flex;
					justify-content: end;
					align-items: center;
					span{
						position: absolute;
						right: -20px;
						width: 0;
						height: 0;
						border-style: solid;
						border-width: 10px 15px;
						border-color: transparent transparent transparent #7F7F7F;

					}
				}	
			}
			.mc{
				font-size: 14px;
				color: #7F7F7F;
				margin: 10px 0 3px;
			}
			.sj{
				font-size: 14px;
				color: #7F7F7F;
			}
		}
	}
	.xqtcCls{
		header{
			height: 50px;
			display: flex;
			align-items: center;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			padding: 0 30px;
			border-bottom: 1px solid #DCDFE6;
			span{
				font-weight: 500;
				font-size: 18px;
				color: #454545;
				margin-right: 25px;
			}
			div{
				padding: 0 8px;
				height: 28px;
				border-radius: 5px;
				font-weight: 400;
				font-size: 16px;
				color: #FFFFFF;
				display: flex;
				align-items: center;
				justify-content: center;
			}
			.shtg{
				background: #4CAF50;
			}
			.shbtg{
				background: #FA5151;
			}
			.wtj{
				background: #757575;
			}
			.shz{
				background: #FF9800;
			}
			.cha{
				width: 16px;
				position: absolute;
				right: 30px;
				cursor: pointer;
			}
		}
	}
}
</style>
